import api from '@/api'
// import { stat } from 'fs'

const state = {
  user: null,
  pharmacy: null,
  hasRegistered: false
}

const getters = {
  user: state => state.user,
  pharmacy: state => state.pharmacy,
  hasRegistered: state => state.hasRegistered
}

const mutations = {
  setUser(state, user) {
    state.user = user
  },
  setPharmacy(state, pharmacy) {
    state.pharmacy = pharmacy
  },
  setHasRegistered(state, hasRegistered) {
    state.hasRegistered = hasRegistered
  }
}

const actions = {
  async getUser ({ commit }) {
    commit('setUser', await api.ap.getUser())
  },
  async getPharmacy({ commit }) {
    commit('setPharmacy', await api.ap.getPharmacy())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}